module.exports = __webpack_public_path__ + "img/atlas-alone.b57034b3.png";